// Gender-specific exit reasons (4857 sayılı İş Kanunu): only military service applies to
// men and the marriage-severance article (Md.14) to women. Health reasons — like every
// other exit type — apply to all genders (it was previously mis-listed as women-only,
// blocking it for men; customer feedback). Employee gender comes from the API as 1=male,
// 2=female; anything else (3=preferNotToSay / unset) imposes no restriction. The backend
// enforces the same rule authoritatively (exitTypeGenderMismatch).
//
// Kept in its own dependency-free module so it can be unit-tested without pulling in the
// config hook's axios/MUI imports (which break the jest ESM transform).
export const MALE_ONLY_EXIT_TYPES = ['military_service'];
export const FEMALE_ONLY_EXIT_TYPES = ['woman_marriage_4857_14'];

export const isExitTypeAllowedForGender = (exitType, gender) => {
  if (gender === 2 && MALE_ONLY_EXIT_TYPES.includes(exitType)) return false;
  if (gender === 1 && FEMALE_ONLY_EXIT_TYPES.includes(exitType)) return false;
  return true;
};
